
import { Component, Vue, Prop } from 'vue-property-decorator';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BalanceSummary } from './components/BalanceSummary';
import { Heading, BaseIcon } from '@warrenbrasil/nebraska-web';

import { formatCurrency } from '@/modules/common/helpers/currency';
import { useDashStore } from '../../store/DashModule';

@Component({
  components: {
    Heading,
    BalanceSummary,
    BaseIcon
  }
})
export default class SectionTitle extends Vue {
  private readonly dashModule = useDashStore();
  private formatCurrency = formatCurrency;
  private NebraskaColors = NebraskaColors;

  @Prop({ type: String, default: 'R$ 0,00' })
  private total!: string;

  @Prop({ type: String, default: '' })
  private title!: string;

  @Prop({ type: String, required: false })
  readonly subTitle?: string;

  @Prop({ type: Boolean, default: false })
  private arrow!: boolean;

  @Prop({ type: Boolean, default: false })
  private forceShowValues!: boolean;

  @Prop({ type: Boolean, default: true })
  private hasDetails!: boolean;

  private shouldShowArrow() {
    return (this.dashModule.showMoney || this.arrow) && this.hasDetails;
  }

  private get computedStyle() {
    if (this.shouldShowArrow()) {
      return 'row-balance__hover';
    }
    return 'row-balance__disabled';
  }
}
